module.exports = __webpack_public_path__ + "media/src/assets/images/avatar-b5139c11f4a541b27d2440f3696a4049.png";